/* import __COLOCATED_TEMPLATE__ from './detailed-view-item.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();